import { type FetchPledgeCampaignsData, minutesToMs, pledgeApi } from '@capsicum/common';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

export const usePledgeCampaignSearchQuery = (
	options?: Omit<UseQueryOptions<FetchPledgeCampaignsData>, 'queryFn' | 'queryKey'>
) => {
	return useQuery({
		queryFn: async () =>
			(await pledgeApi).fetchPledgeCampaigns({
				statuses: ['opened']
			}),
		queryKey: ['pledge-campaign-search'],
		staleTime: minutesToMs(5),
		...options
	});
};
